module.exports = __webpack_public_path__ + "static/004_Gippsland-b30df2bde19e42eeb9821cf9e128be6b.jpg";